document.addEventListener("DOMContentLoaded", function () {
  //eventListeners();
  navSlide();
  año();
  irArriba();
  //cookies();
});

function navSlide() {
  const burger = document.querySelector(".burger");
  const nav = document.querySelector(".nav-links");
  const navLinks = document.querySelectorAll(".nav-links li");

  burger.addEventListener("click", () => {
    //Toggle Nav
    nav.classList.toggle("nav-active");

    //Animate Links
    navLinks.forEach((link, index) => {
      if (link.style.animation) {
        link.style.animation = "";
      } else {
        link.style.animation = `navLinkFade 0.4s ease forwards ${
          index / 20 + 0.5
        }s`;
      }
    });
    //Burger Animation
    burger.classList.toggle("toggle");
  });
}

function año() {
  date = new Date();
  año = date.getFullYear();
  document.getElementById("año").innerHTML = año;
}

function irArriba() {
  const btn_scrolltop = document.getElementById("btn_scrolltop");
  btn_scrolltop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  window.onscroll = () => {
    add_btn_scrolltop();
  };

  const add_btn_scrolltop = () => {
    if (window.scrollY < 300) {
      btn_scrolltop.classList.remove("btn-scrolltop-on");
    } else {
      btn_scrolltop.classList.add("btn-scrolltop-on");
    }
  };
}

/*function cookies() {
  const botonAceptarCookies = document.getElementById("btn-aceptar-cookies");
  const avisoCookies = document.getElementById("aviso-cookies");
  const fondoAvisoCookies = document.getElementById("fondo-aviso-cookies");

  dataLayer = [];

  if (!localStorage.getItem("cookies-aceptadas")) {
    avisoCookies.classList.add("activo");
    fondoAvisoCookies.classList.add("activo");
  } else {
    dataLayer.push({ event: "cookies-aceptadas" });
  }

  botonAceptarCookies.addEventListener("click", () => {
    avisoCookies.classList.remove("activo");
    fondoAvisoCookies.classList.remove("activo");

    localStorage.setItem("cookies-aceptadas", true);

    dataLayer.push({ event: "cookies-aceptadas" });
  });
}*/

/* Cookies 2
function cookies() {
  const botonAceptarCookies = document.getElementById("btn-aceptar-cookies");
  const botonRechazarCookies = document.getElementById("btn-rechazar-cookies"); // Obtener el botón "Rechazar"
  const avisoCookies = document.getElementById("aviso-cookies");
  const fondoAvisoCookies = document.getElementById("fondo-aviso-cookies");

  dataLayer = [];

  if (!localStorage.getItem("cookies-aceptadas") || localStorage.getItem("cookies-aceptadas") === "false") {
    avisoCookies.classList.add("activo");
    fondoAvisoCookies.classList.add("activo");
  } else {
    dataLayer.push({ event: "cookies-aceptadas" });
  }

  botonAceptarCookies.addEventListener("click", () => {
    avisoCookies.classList.remove("activo");
    fondoAvisoCookies.classList.remove("activo");

    localStorage.setItem("cookies-aceptadas", true);

    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7); // Establecer la fecha de expiración a una semana a partir de hoy
    document.cookie = `cookies-aceptadas=true;expires=${expirationDate.toUTCString()};path=/`; // Guardar la cookie con la fecha de expiración

    dataLayer.push({ event: "cookies-aceptadas" });
  });

  botonRechazarCookies.addEventListener("click", () => { // Agregar evento de clic al botón "Rechazar"
    avisoCookies.classList.remove("activo");
    fondoAvisoCookies.classList.remove("activo");

    localStorage.setItem("cookies-aceptadas", false); // Establecer la clave "cookies-aceptadas" en false

    document.cookie = "cookies-aceptadas=false;path=/"; // Guardar la cookie sin establecer una fecha de expiración

    dataLayer.push({ event: "cookies-rechazadas" }); // Enviar evento de rechazo de cookies
  });
}
*/




